module.exports = __webpack_public_path__ + "static/media/music.7527caa.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/triennial/start/music.mp3
// module id = AFab
// module chunks = 1